import { render, staticRenderFns } from "./LoaderService.vue?vue&type=template&id=6caf2499"
import script from "./LoaderService.vue?vue&type=script&lang=js"
export * from "./LoaderService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports